/**
 * Utility functions for tag operations
 */
import { supabase } from '../supabase';

/**
 * Fetch tag options from Supabase for a given venue
 * @param {number} venueId - The ID of the venue
 * @returns {Promise<Object>} - Options and mappings for tags
 */
export const populateTagOptionsSupabase = async (venueId) => {
  try {
    let query = supabase
      .from('tags')
      .select('tag, name, category');
    
    // Filter tags based on venue_id
    if (venueId) {
      query = query.eq('venue_id', venueId);
    } else {
      // Default to Gent (venue_id=1)
      query = query.eq('venue_id', 1);
    }
    
    const { data, error } = await query;


    if (error) {
      console.error('Error fetching tags:', error);
      return { options: [], mappings: {} };
    }

    // Create a mapping of display names to actual tag IDs, and a list of all tags to display in the autocomplete
    const tagMappings = {};
    const displayOptions = [];

    data.forEach(item => {
      if (item.tag && item.name) {
        // Create a display format as "tag: name" for better visualization
        const displayFormat = `${item.tag}: ${item.name}`;
        displayOptions.push(displayFormat);
        tagMappings[displayFormat] = item.tag; // Map the display format to the tag value
      } else if (item.tag) {
        // If only tag exists, use it as is
        displayOptions.push(item.tag);
        tagMappings[item.tag] = item.tag;
      } else if (item.name) {
        // If only name exists, use it as is
        displayOptions.push(item.name);
        tagMappings[item.name] = item.name;
      }
    });

    // Sort the tags
    displayOptions.sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));

    return {
      options: Array.from(new Set(displayOptions)),
      mappings: tagMappings
    };
  } catch (err) {
    console.error('Error in populateTagOptionsSupabase:', err);
    return { options: [], mappings: {} };
  }
}; 